import Axios from "axios";

const httpAxios = Axios.create({
  baseURL:
    process.env.VUE_APP_BASE_URL &&
    process.env.VUE_APP_BASE_URL !== "" &&
    process.env.VUE_APP_BASE_URL !== null
      ? process.env.VUE_APP_BASE_URL
      : "http://localhost:8888",
});

export default httpAxios;
